const filters = {
  filterStatus: (value) => {
    return {
      0: '未处理',
      1: '已处理'
    }[Number(value)]
  },
  filterStatus4: (value) => {
    return {
      0: '未认领',
      1: '未整改',
      2: '未核验',
      3: '已完成'
    }[Number(value)]
  },
  filterStatus2: (value) => {
    return {
      0: '已通过',
      1: '已拒绝'
    }[Number(value)]
  },
  filterStatus3: (value) => {
    return {
      0: '未转派',
      10: '转派中',
      20: '转派成功'
    }[Number(value)]
  },
  filterBrandName(value, brands) {
    return brands.some(item => String(item.brandId) === String(value))
      ? brands.find(item => String(item.brandId) === String(value)).brandName
      : undefined
  },
  filterAccuseTypes(value, replyTypeList) {
    if (!value) {
      return ''
    }
    let str = ''
    value.split(',').forEach(item => {
      const it = replyTypeList.find(i => String(i.id) === String(item))
      if (it) {
        str += `${it.title},`
      }
    })
    return str.slice(0, str.length - 1)
  },
  formatTime(msTime) {
    if (!msTime) {
      return '未整改'
    }
    const time = msTime / 1000
    const day = Math.floor(time / 60 / 60 / 24)
    const hour = Math.floor(time / 60 / 60) % 24
    const minute = Math.floor(time / 60) % 60
    const second = Math.floor(time) % 60
    if (day > 0) {
      return `${day}天${hour}时${minute}分${second}秒`
    } else {
      return `${hour}时${minute}分${second}秒`
    }
  },
  formatTime2(msTime) {
    if (msTime<0||msTime=='-') {
      return '-'
    }
    const time = msTime / 1000
    const day = Math.floor(time / 60 / 60 / 24)
    const hour = Math.floor(time / 60 / 60) % 24
    const minute = Math.floor(time / 60) % 60
    const second = Math.floor(time) % 60
    if (day > 0) {
      return `${day}天${hour}时${minute}分${second}秒`
    } else {
      return `${hour}时${minute}分${second}秒`
    }
  },
  filterRuleConfig(val) {
    if (!val) {
      return ''
    } else {
      return JSON.parse(val).title
    }
  },
  filterMoldStatus(value) {
    if (value) {
      return {
        100: '重点区域偏多调度',
        150: '普通区域偏多调度',
        200: '站外还车调度',
        250: '非法车辆调度'
      }[Number(value)]
    } else {
      return '-'
    }
  },
  filterMatchStatus(value) {
    if (value) {
      return {
        0: '未匹配',
        1: '自动匹配',
        2: '手动匹配'
      }[Number(value)]
    } else {
      return '-'
    }
  },
  filterMaintainGroup(value) {
    return {
      0: '非组成员',
      1: '勘察',
      2: '审核',
      3: '划线',
      4: '安装'
    }[Number(value)]
  },
  filterGroup(value) {
    return {
      0: '调度员',
      1: '勘察',
      2: '审核',
      3: '划线',
      4: '安装'
    }[Number(value)]
  },
  filterApplyStatus(value) {
    return {
      0: '处理中',
      1: '通过',
      2: '已拒绝'
    }[Number(value)]
  },
  filterApplyStationStatus(row, currTab) {
    const auditCurrent = Number(row.auditCurrent)
    const applyStatus = Number(row.applyStatus)
    if (auditCurrent === 2 && applyStatus === 0) {
      return '待审核'
    } else if (auditCurrent === 2 && applyStatus === 3) {
      return '审核拒绝'
    } else if (auditCurrent === 3 && applyStatus === 0) {
      return '待画线'
    } else if (auditCurrent === 3 && applyStatus === 3) {
      return '不可画线'
    } else if (auditCurrent === 4 && applyStatus === 0) {
      return '待安装'
    } else if (auditCurrent === 4 && applyStatus === 1) {
      return '已安装'
    }
  },
  // filterApplyStationStatus(row, currTab) {
  //   const o = {
  //     200: {
  //       1: '待审核',
  //       2: '已审核'
  //     },
  //     1000: {
  //       1: '待画线',
  //       2: '已画线'
  //     },
  //     1100: {
  //       1: '待安装',
  //       2: '已安装'
  //     },
  //     1200: {
  //       1: '已拒绝',
  //       2: '已拒绝'
  //     },
  //     1300: {
  //       1: '不可画线',
  //       2: '不可画线'
  //     }
  //   }
  //   const oo = o[Number(currTab.id)]
  //   return (Number(row.auditCurrent) === 2 && Number(row.applyStatus) === 0) ? oo[1] : oo[2]
  // },
  getAreaNames(value, nationalArea) {
    let str = ''
    if (!value.regionId) {
      str = '全国'
    } else if (value.cityId) {
      // 省市区
      const provice = nationalArea.find(item => item.id === value.provinceId)
      const city = nationalArea.find(item => item.id === value.cityId)
      const region = nationalArea.find(item => item.id === value.regionId)
      str = `${provice.areaName} ${city.areaName} ${region.areaName}`
    }
    return str
  },
  getAreaNamesByAddress(value, nationalArea, userLevel, userSelfAreaId) {
    // 全国：省市区
    // 省：市区
    // 市：县区
    // 区：区
    let str = ''
    if (value.regionId === undefined || value.regionId === null) {
      return ''
    }
    if (value.regionId === '') {
      str = '全国'
      return str
    }
    const provice = nationalArea.find(item => String(item.id) === String(value.provinceId))
    const city = nationalArea.find(item => String(item.id) === String(value.cityId))
    const region = nationalArea.find(item => String(item.id) === String(value.regionId))
    if (String(userLevel) === '0') {
      if (String(userSelfAreaId) === '000000') {
        // 全国
        str = `${provice.areaName} ${city.areaName} ${region.areaName}`
      } else {
        // 省
        str = `${city.areaName} ${region.areaName}`
      }
    } else if (String(userLevel) === '1') {
      // 市
      str = `${region.areaName}`
    } else if (String(userLevel) === '2') {
      // 区县
      str = `${region.areaName}`
    }
    return str
  },
  getInvestigateName(value) {
    let txt = ''
    const v = Number(value)
    if (v === 0) {
      txt = '普通用户'
    } else if (v === 1) {
      txt = '勘察组'
    }
    return txt
  }
}

export default filters
